// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const HearLargeFilledIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M23 4.72a5.9 5.9 0 00-2.69-2.25 5.75 5.75 0 00-3.45-.35 6 6 0 00-3 1.68L12 5.72 10.1 3.8a6 6 0 00-3-1.68 5.75 5.75 0 00-3.45.35A5.92 5.92 0 001 4.72a6.18 6.18 0 00-1 3.37c0 1.63.52 2.68 2.13 4.33L11 21.59l.09.07a1.39 1.39 0 001.82 0l8.94-9.21C23.46 10.79 24 9.69 24 8.09a6.18 6.18 0 00-1-3.37z"/></svg>'} />;

HearLargeFilledIcon.displayName = 'HearLargeFilledIcon';

export default HearLargeFilledIcon;
